import { render, staticRenderFns } from "./recurso-acessibilidade-component.vue?vue&type=template&id=aa0ee370&"
import script from "./recurso-acessibilidade-component.vue?vue&type=script&lang=ts&"
export * from "./recurso-acessibilidade-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa0ee370')) {
      api.createRecord('aa0ee370', component.options)
    } else {
      api.reload('aa0ee370', component.options)
    }
    module.hot.accept("./recurso-acessibilidade-component.vue?vue&type=template&id=aa0ee370&", function () {
      api.rerender('aa0ee370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/recurso-acessibilidade-component.vue"
export default component.exports